export type OrganizationConnectionEdges = {
  edges: [{ properties: { version: string; notBefore: string; notAfter: string } }];
};

export type LicensedProductNextcloud = {
  __typename?: 'Nextcloud';
  uuid?: string;
  serverUri?: string;
  serverAliase?: string;
  adminUser?: string;
  adminPass?: string;
  organizationConnection?: OrganizationConnectionEdges;
};

export const Products = [
  'Nextcloud',
  'Zoom',
  'BigBlueButton',
  'Threema',
  'ThreemaBroadcast',
  'Bildungsplattform',
] as const;

export type LicensedProductTypes = (typeof Products)[number];
